import * as React from "react"

function DateIcon(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg
            width={props?.width ? props.width : "20"}
            height={props?.height ? props.height : "20"}
            viewBox="0 0 24 24"
            fill={props.fill ? props.fill : "none"}
            xmlns="http://www.w3.org/2000/svg"
            {...props}>
            <path
                d="M17 3h4a1 1 0 011 1v16a1 1 0 01-1 1H3a1 1 0 01-1-1V4a1 1 0 011-1h4V1h2v2h6V1h2v2zm3 8H4v8h16v-8zm-5-6H9v2H7V5H4v4h16V5h-3v2h-2V5zm-9 8h2v2H6v-2zm5 0h2v2h-2v-2zm5 0h2v2h-2v-2z"
                className={
                    props.className
                        ? props.className
                        : "dark:fill-gray-200 fill-gray-500"
                }
            />
        </svg>
    )
}

export default DateIcon
